/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Brand } from '../models/Brand';
import type { Brewery } from '../models/Brewery';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class BrewDatService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Get breweries from brewdat
   * Gets the breweries from brewdat
   * @returns Brewery Success
   * @throws ApiError
   */
  public brewDatGetBrewery(): CancelablePromise<Array<Brewery>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/brew-dat/brewery',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
  /**
   * Get brands from brewdat
   * Gets the brands from brewdat
   * @returns Brand Success
   * @throws ApiError
   */
  public brewDatGetBrand(): CancelablePromise<Array<Brand>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/brew-dat/brand',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
}
